module.exports = __webpack_public_path__ + "static/media/Group237655.42d4a927.webp";